import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  whyChooseUs: {
    fontFamily: Theme.typography.base.regular,
  },
  sectionWrapper: {
    maxWidth: '1080px',
  },
  text: {
    fontFamily: Theme.typography.base.regular,
    '& span': {
      color: Theme.palette.gray[800],
      fontSize: Theme.typography.size[6.5],
      lineHeight: '150%',
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[7],
      },
    },
    '& p': {
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      margin: 0,
      marginTop: 10,
      marginBottom: 20,
      color: Theme.palette.gray[750],
      '& >label': {
        fontFamily: Theme.typography.base.semiBold,
      },
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },
  },
  cardWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 20,
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  card: {
    borderRadius: 5,
    textAlign: 'left',
    padding: '30px 20px',
    width: '100%',
    boxSizing: 'border-box',
    '& img': {
      height: '26px',
      width: '26px',
      marginBottom: '20px',
      objectFit: 'contain',
    },
    '& h3': {
      textAlign: 'left',
      margin: 0,
      marginBottom: '10px',
      color: Theme.palette.gray[800],
      fontSize: Theme.typography.size[4],
      fontFamily: Theme.typography.base.semiBold,
    },
    '& p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      margin: 'auto',
      '& label': {
        fontFamily: Theme.typography.base.semiBold,
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[3],
      },
    },
    [Theme.breakpoints.up('md')]: {
      width: '33.33%',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '50px 35px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '50px 30px',
    },
  },

  ukSvg: {
    marginLeft: '-30px',
  },
}));

export default useStyles;
